// extracted by mini-css-extract-plugin
module.exports = {"box":"LocationInput_box__n1awn","input":"LocationInput_input__hsC5b","icon":"LocationInput_icon__uhX8P"};